import numbersFormatting from './numbersFormatting';

export default numbersFormatting;
